import groupBy from 'lodash/groupBy';

import { useEffect, useState } from 'react';
import { LearnEntityResponseCollection, LearnPage } from '@/graphql/generated/graphql';
import CoursesSkeleton from '../courses/Courses.skeleton';
import AnimatedList, { courseWithLearnProps } from './animatedList';
import { fetchLearn, getPage } from '@/services/learn/learn.service';
import { getCourseCategoriesByLearn } from '@/utils/learn';
import Container from '@/components/Container';
import Navigation from '@/components/ui/navigation';
import { navigationLearn } from '../constants';

function CoursesInProgressTab() {
  const [learn, setLearn] = useState<LearnEntityResponseCollection | null>(null);
  const [learnPage, setLearnPage] = useState<LearnPage | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    (async () => {
      setLoading(true);

      const [pageResponse, learnResult] = await Promise.all([getPage(), fetchLearn({ completed: false })]);

      setLearnPage(pageResponse.page);
      setLearn(learnResult);
      setLoading(false);
    })();
  }, []);

  const courses =
    learn?.data?.map((l) => ({
      ...l?.attributes?.course?.data,
      learn: l?.attributes,
      learnCount: l?.attributes?.learn_items?.data.length || 0,
    })) || [];

  const coursesData = courses?.map((c) => ({
    ...c,
    category: c?.attributes?.course_category?.data?.attributes?.name,
  }));

  const categories = getCourseCategoriesByLearn(courses);
  const courseGroupedByCategory = groupBy(coursesData, 'category') || {};

  if (loading) {
    return (
      <Container className="min-h-40">
        <CoursesSkeleton />
      </Container>
    );
  }

  return (
    <>
      <Navigation title="Learn" items={navigationLearn} />
      <Container className="min-h-40">
        {!learn?.data?.length || learn?.data?.length === 0 ? (
          <div className="col-span-12 mt-8 text-center">
            {learnPage?.emptyInProgressCoursesMessage || `You don't have any courses in progress yet`}
          </div>
        ) : null}
        {Object.keys(categories)
          .map((category) => ({
            name: category,
            courses:
              (courseGroupedByCategory[category]?.map((course) => ({
                ...course?.attributes,
                learn: {
                  completed: course?.learn?.completed,
                  learnCount: course?.learnCount,
                },
              })) as courseWithLearnProps[]) || [],
            description: categories[category]?.description || '',
          }))
          .map((category) => (
            <AnimatedList category={category} key={category?.name} />
          ))}
      </Container>
    </>
  );
}

export default CoursesInProgressTab;
